export default __webpack_public_path__ + "static/media/loko2.8b12259d.PNG";